import React from "react";
import { SpaceBetween, Box } from "@cloudscape-design/components";

const FinancePaymentsHelp = () => (
  <SpaceBetween size="m">
    <Box>
      <strong>Purpose</strong>
      <p>
        Track payment requests from draft through finance handoff. Finance delivery mode labels them Payment emails for email or Payment packets for direct API integration. Each request groups the specific payment lines and
        evidence being sent now; it is not the full approved intervention by default.
      </p>
    </Box>
    <Box>
      <strong>What this dashboard covers</strong>
      <ul>
        <li>Payment emails or Payment packets: focus current requests, blockers, and ageing.</li>
        <li>Detail: inspect and progress the currently selected request's lines, evidence, send status, and follow-up.</li>
        <li>Communications: review outbound finance emails and follow-ups for the selected request or across all requests.</li>
        <li>SLA snapshot: optional summary card available from the widget palette when needed.</li>
      </ul>
    </Box>
    <Box>
      <strong>Key rules</strong>
      <ul>
        <li>Finance Settings determines which evidence must be attached or held on file, and whether a missing item warns or blocks sending.</li>
        <li>Recurrence and service-period requirements are enforced per payment type from Finance Settings.</li>
        <li>Approved intervention funding is the authorization ceiling; create separate requests for separate months, receipts, or claim periods.</li>
        <li>In email mode, the client-file composer sends to its reviewed To and CC recipients. Sending locks normal edits to the submitted request.</li>
        <li>Reporting unit and region metadata drive finance routing and audit context.</li>
      </ul>
    </Box>
    <Box>
      <strong>Quick start</strong>
      <ol>
        <li>Start new payment requests from the client file’s intervention detail or payment widget. Use the dashboard queue to review existing requests.</li>
        <li>Select one request in the queue to inspect its detail and evidence.</li>
        <li>Review communications for that request or clear selection to return to the broader picture.</li>
      </ol>
    </Box>
    <Box>
      <strong>Next steps</strong>
      <p>
        Use queue filters to prioritise drafts, keep the communications log complete, and monitor SLA buckets to keep
        finance sends moving.
      </p>
    </Box>
  </SpaceBetween>
);

FinancePaymentsHelp.aiContext =
  "Finance delivery mode determines the shared labels: email uses Payment emails and Prepare payment email; direct API integration uses Payment packets and Prepare payment packet. Explain the Payments dashboard as the operational payments surface: new preparation starts only in the client file through the configured Prepare action; the dashboard has no creation action. The compact composer shows editable recipients, subject and notes around controlled payment lines and attachments, with configured evidence warning/block and attachment/on-file rules. Attachments shows the files being sent plus missing required attachments; on-file checks sit in a separate disclosure below the email preview, collapsed when satisfied and opened when missing. PDFs open in separate tabs, and removing an attachment leaves the document on file. Single-request queue selection drives the detail panel, communications can show the active request or all requests, SLA snapshot is optional in the palette, approved intervention funding is an authorization ceiling rather than a request amount, and sending locks normal edits. In email mode, the reviewed payment email is sent to Finance. Intervention details default to Unsent and offer Sent for submitted or confirmed payments; the dashboard retains its existing queue filters.";

export default FinancePaymentsHelp;
